// extracted by mini-css-extract-plugin
export var content = "style-module--content--98421";
export var gift = "style-module--gift--3ae8b";
export var giftTxt = "style-module--gift-txt--95f89";
export var img = "style-module--img--2ca29";
export var people = "style-module--people--77fd7";
export var screen1 = "style-module--screen1--ec501";
export var time = "style-module--time--cfaf3";
export var timeWrap = "style-module--time-wrap--364a1";
export var timer = "style-module--timer--0b1e1";
export var type = "style-module--type--0f459";
export var wrap = "style-module--wrap--723bb";
export var wrapper = "style-module--wrapper--ad543";